import cx from 'classnames';
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styles from './day.module.scss';
const getPrice = ({ price, isRelative }) => {
    if (!price) {
        return '';
    }
    const fixedPrice = Math.abs(price).toFixed(0);
    if (isRelative) {
        if (price > 0) {
            return <span className={styles.relativePositive}>+£{fixedPrice}</span>;
        }
        if (price < 0) {
            return <span>-£{fixedPrice}</span>;
        }
        return <span>£0</span>;
    }
    return `£${fixedPrice}`;
};
const Day = ({ dateIndex, dateValue, selected, hovered, disabled, disabledEndOfSeason, onSelectDate, onHoverDate, isEndDay, isStartDay, highlight, leadingPrice, soldOut, isLeadingPricesEnabled = false, showRelativePricing = false, }) => {
    const selectDate = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (disabled)
            return;
        onSelectDate(dateValue, isLeadingPricesEnabled ? leadingPrice === null || leadingPrice === void 0 ? void 0 : leadingPrice.price : undefined);
    };
    const handleHoverDate = () => {
        if (disabled || !onHoverDate)
            return;
        onHoverDate(dateValue);
    };
    const price = getPrice({ price: leadingPrice === null || leadingPrice === void 0 ? void 0 : leadingPrice.price, isRelative: showRelativePricing });
    return (<div className={styles.dayContainer}>
      <button className={cx(styles.day, selected && styles.selected, hovered && styles.hovered, disabled && styles.disabled, disabledEndOfSeason && styles.disabledEndOfSeason, highlight && styles.highlight, isEndDay && selected && styles.endDay, isStartDay && selected && styles.startDay, soldOut && styles.soldOut)} onClick={selectDate} onMouseEnter={handleHoverDate} disabled={disabled} tabIndex={-1} data-day-index={dateIndex} data-date-value={dateValue}>
        <div className={styles.textDay}>{dateIndex}</div>
      </button>
      {isLeadingPricesEnabled && price ? (<div className={cx(styles.leadingPrice)}>{price}</div>) : null}
    </div>);
};
export default Day;
